import { render } from "./TOV.vue?vue&type=template&id=477c6122"
import script from "./TOV.vue?vue&type=script&lang=js"
export * from "./TOV.vue?vue&type=script&lang=js"

import "./TOV.vue?vue&type=style&index=0&id=477c6122&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__